// extracted by mini-css-extract-plugin
export default {"hidden":"a11y-module--hidden--c0699"};